<template>
  <div>
    <a href="https://www.markdownguide.org/basic-syntax/" target="_blank">
      <p class="font-bold mb-2 text-STorange hover:underline">
        Supports Markdown
      </p>
    </a>
    <FormContainer>
      <form
        @submit="handleSubmit"
        class="bg-white drop-shadow-lg shadow-2xl p-8"
      >
        <div class="mb-3">
          <label class="form-label">Apply Here Link</label>
          <input type="url" class="form-input" v-model="form.applyLink" />
        </div>
        <div class="mb-3">
          <label class="form-label form-required"> Role </label>
          <input class="form-input" v-model="form.role" rows="1" required />
        </div>
        <div class="mb-3">
          <label class="form-label form-required"> Overview </label>
          <textarea
            class="form-input"
            v-model="form.overview"
            rows="4"
            required
          ></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label form-required"> Responsibilities </label>
          <textarea
            class="form-input"
            v-model="form.responsibilities"
            rows="4"
            required
          ></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label form-required">
            Qualifications
          </label>
          <textarea
            class="form-input"
            v-model="form.skills"
            rows="4"
            required
          ></textarea>
        </div>

        <div class="grid grid-cols-2 gap-x-5">
          <div class="mb-3">
            <label class="form-label"> Travel </label>
            <input class="form-input" v-model="form.reportsTo" />
          </div>

          <div class="mb-3">
            <label class="form-label"> Location </label>
            <input class="form-input" v-model="form.location" />
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label form-required"> Benefits </label>
          <textarea
            class="form-input"
            v-model="form.compensation"
            rows="1"
            required
          ></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label form-required"> Date </label>
          <input
            class="form-input h-10"
            type="date"
            v-model="form.date"
            required
          />
        </div>

        <div class="mb-3">
          <label class="form-label" :class="!editMode && 'form-required'">
            {{ editMode ? "Upload new pdf" : "Upload pdf" }}
          </label>
          <input
            type="file"
            accept=".pdf"
            class="form-input"
            ref="file"
            @change="getFile"
            :required="!editMode"
          />
        </div>

        <button class="mt-4 py-2 px-3 bg-STblue text-white w-full rounded">
          {{ editMode ? "Update" : "Submit" }}
        </button>
      </form>

      <JobPostingsPreview :form="form" />
    </FormContainer>

    <div class="mt-10" v-if="form.role">
      <p class="text-lg">How it will be displayed on the careers page</p>
      <JobPosting
        class="mt-5"
        :header="form.role"
        :date="form.date"
        :previewMode="true"
      />
    </div>
  </div>
</template>

<script>
import JobPosting from "./JobPosting.vue";
import FormContainer from "../FormContainer.vue";
import JobPostingsPreview from "../Careers/JobPostingsPreview.vue";

export default {
  name: "JobPostingsForm",

  props: {
    form: Object,
    editMode: Boolean,
  },

  components: {
    FormContainer,
    JobPostingsPreview,
    JobPosting,
  },

  methods: {
    getFile() {
      this.$emit("getFile", this.$refs.file.files);
    },

    handleSubmit(e) {
      e.preventDefault();

      this.$emit("handleSubmit");
    },
  },
};
</script>
